(() => {
 
    jQuery(document).ready(function ($) {

        const container = document.querySelector('.qte-section-faq-page');

        if (!container) { 
            return;
        }

        const items = container.querySelector('.items').children;
        const buttons = container.querySelectorAll('.button');


        buttons.forEach(button => {

 
            button.addEventListener('click', () => {

                //remove active class from all buttons
                buttons.forEach(button => {
                    button.classList.remove('active');
                });

                //add active class to clicked button
                button.classList.add('active');

                const id = button.dataset.id;
    
                //if id = '', show all items
                if (id === undefined) {
                    [...items].forEach(item => {
                        item.style.display = 'block';
                    });
                    return;
                }

                //if items.dataset.ids does not contain id, hide it
                [...items].forEach(item => {
                    if (item.dataset.ids.includes(id)) {
                        item.style.display = 'block';
                    } else {
                        item.style.display = 'none';
                    }
                });


            });
        });

        
    });
})();